import { type ResultOf } from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation CustomerAttributeSettingsPage_DeleteCustomerAttributeGroup(
    $customerAttributeGroupId: ID!
  ) {
    deleteCustomerAttributeGroup(id: $customerAttributeGroupId) {
      result
    }
  }
`)

export const useDeleteCustomerAttributeGroupMutation = (
  options: Omit<
    UseMutationOptions<ResultOf<typeof document>, unknown, string, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (customerAttributeGroupId) =>
      graphQLRequest({ document, variables: { customerAttributeGroupId } }),
    ...options,
  })
}
